/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
// libraries
import classNames from "classnames";

// material ui components
import TextareaAutosize, {
  TextareaAutosizeProps,
} from "@mui/material/TextareaAutosize";
import Box from "@mui/material/Box";

// styles
import styles from "./styles.module.css";

export enum InputType {
  DEFAULT = "DEFAULT",
  NUMBER = "NUMBER",
}

interface Props extends TextareaAutosizeProps {
  label?: string;
  defaultValue?: string;
  maxCharacters?: number;
  // eslint-disable-next-line no-unused-vars
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  type?: InputType;
  required?: boolean;
}

const TextInput = ({
  label = "",
  defaultValue = "",
  maxCharacters = 100,
  handleChange,
  required,
  type = InputType.DEFAULT,
  ...props
}: Props) => {
  const [value, setValue] = useState<string | number>("");
  const [error, setError] = useState<boolean>(false);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
      setError(false);
      setValue(e.target.value);
      handleChange(e);
    },
    [value]
  );

  useEffect(() => {
    if (required && !value) setError(true);
  }, [required, value]);

  const validateNumber = (
    value: React.KeyboardEvent<HTMLTextAreaElement>["key"]
  ) => {
    if (/[0-9]/.test(value)) return true;
    return false;
  };

  const errorClass = error ? styles.error : "";

  return (
    <Box className={classNames(styles.container, errorClass)}>
      <div className={styles["header"]}>
        <p>{label}</p>
      </div>
      <TextareaAutosize
        className={classNames(
          styles["text_area"],
          type === InputType.NUMBER ? styles["number"] : ""
        )}
        aria-label="maximum height"
        defaultValue={defaultValue}
        onChange={onChange}
        disabled={String(value).length >= maxCharacters}
        style={{
          width: "100%",
          minHeight: "16px",
        }}
        onKeyPress={(event) => {
          if (!validateNumber(event?.key) && type === InputType.NUMBER)
            event.preventDefault();
        }}
        {...props}
      />
    </Box>
  );
};

export default React.memo(TextInput);
